module.exports = __webpack_public_path__ + "static/img/AGC.7b992e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/AGC.png
// module id = OTY4
// module chunks = 34